exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2pE1e0Fny4M9KTwDkqyF8B{vertical-align:text-top}html[dir=ltr] ._2pE1e0Fny4M9KTwDkqyF8B{padding-left:2px}html[dir=rtl] ._2pE1e0Fny4M9KTwDkqyF8B{padding-right:2px}._1lCoWkLhqbfhMu51qa9m-P{color:#c50e2e}", ""]);

// exports
exports.locals = {
	"linkSpinner": "_2pE1e0Fny4M9KTwDkqyF8B",
	"linkWithSharingIssue": "_1lCoWkLhqbfhMu51qa9m-P"
};